import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";
import GenericCrudModule from "@/components/GenericCrudModule";
import ContextButton from "@/components/ContextButton";
import ThreeQPageHeader from "@/components/ThreeQPageHeader";

const STATUT_COLORS = { active: "#1D9E75", mute: "#A1A1AA", declenchee: "#E24B4A" };

export default function Alertes() {
  const { t } = useTranslation();
  return (
    <>
      <ThreeQPageHeader endpoint="/workspace/alertes/top-priority" className="mb-4" />
      <GenericCrudModule
      module={{
        path: "alertes",
        title: t("saas.alertes.title"),
        overline: t("saas.alertes.overline"),
        subtitle: t("saas.alertes.subtitle"),
        accent: "#EF9F27", icon: Bell, dataTestId: "alertes",
      }}
      fields={[
        { key: "titre", label: t("saas.alertes.field_titre"), required: true, span: 2,
          placeholder: t("saas.alertes.field_titre_ph") },
        { key: "scope", label: t("saas.alertes.field_scope"), type: "select", default: "risque",
          options: ["risque", "controle", "incident", "score"].map((v) => ({ value: v, label: t(`saas.alertes.scopes.${v}`) })) },
        { key: "canal", label: t("saas.alertes.field_canal"), type: "select", default: "dashboard",
          options: ["dashboard", "email", "both"].map((v) => ({ value: v, label: t(`saas.alertes.canaux.${v}`) })) },
        { key: "seuil", label: t("saas.alertes.field_seuil"), required: true, span: 2,
          placeholder: t("saas.alertes.field_seuil_ph") },
        { key: "statut", label: t("saas.alertes.field_statut"), type: "select", default: "active",
          options: ["active", "mute", "declenchee"].map((v) => ({ value: v, label: t(`saas.alertes.statuts.${v}`) })) },
        { key: "commentaire", label: t("saas.alertes.field_commentaire"), type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "titre", label: t("saas.alertes.col_alerte"), render: (r) => r.titre || r.title || r.name || t("saas.alertes.value_missing", { defaultValue: "Sans titre" }) },
        { key: "scope", label: t("saas.alertes.col_scope"), render: (r) => t(`saas.alertes.scopes.${r.scope}`, { defaultValue: r.scope || "Non défini" }) },
        { key: "seuil", label: t("saas.alertes.col_seuil"), render: (r) => r.seuil || r.threshold || r.condition || t("saas.alertes.value_missing", { defaultValue: "Non défini" }) },
        { key: "canal", label: t("saas.alertes.col_canal"), render: (r) => t(`saas.alertes.canaux.${r.canal}`, { defaultValue: r.canal || "Non défini" }) },
        { key: "statut", label: t("saas.alertes.col_statut"), render: (r) => (
          <span className="text-[10px] px-2 py-0.5 rounded-full font-medium uppercase tracking-wider"
            style={{ background: `${STATUT_COLORS[r.statut] || "#A1A1AA"}1A`, color: STATUT_COLORS[r.statut] }}>
            {t(`saas.alertes.statuts.${r.statut}`, { defaultValue: r.statut || "Non défini" })}
          </span>
        )},
      ]}
      emptyMsg={t("saas.alertes.empty_msg")}
      primaryCta={t("saas.alertes.primary_cta")}
      headerActions={<ContextButton moduleKey="alertes" />}
      kpis={(data) => {
        const items = data.items || [];
        const total = items.length;
        const actives = items.filter((i) => i.statut === "active").length;
        const declenchees = items.filter((i) => i.statut === "declenchee").length;
        const emails = items.filter((i) => i.canal === "email" || i.canal === "both").length;
          const hasValue = (...values) => values.some((value) => value !== null && value !== undefined && String(value).trim() !== "");
          const unconfigured = items.filter((item) => !hasValue(item.scope) || !hasValue(item.seuil, item.threshold, item.condition) || !hasValue(item.canal) || !hasValue(item.statut)).length;
        return [
          { label: t("saas.alertes.kpi_total"), value: total },
          { label: t("saas.alertes.kpi_unconfigured"), value: unconfigured, color: "#F59E0B" },
          { label: t("saas.alertes.kpi_active"), value: actives, color: "#1D9E75" },
          { label: t("saas.alertes.kpi_declenchee"), value: declenchees, color: "#E24B4A" },
          { label: t("saas.alertes.kpi_email"), value: emails, color: "#378ADD" },
        ];
      }}
    />
    </>
  );
}
